import axios from "../../../../axios";

import React, { useState } from "react";
import "./queryList.css";
import { toast } from "react-toastify";

const DeleteQuery = ({
  setQuery,
  queryId,
  setDeleteQuery,
  setDelQuery,
  handleRefresh,
}) => {
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const [isInProgress, setIsInProgress] = useState(false);
  let user_id = teacher_id;
  const handleDeleteQuery = async () => {
    setIsInProgress(true);
    try {
      let res = await axios.delete(`/api/v1/query/delete/${queryId}`, {
        data: { user_id },
      });
      res && handleRefresh();
      setDelQuery(true);
      setDeleteQuery(false);
      toast.success(res?.data?.message);
    } catch (error) {
      setIsInProgress(false);
      toast.error(error.response.data.message);
      console.log(error);
    }
  };
  return (
    <div className=" delete_query_transprant_body ">
      <img
        src="/images/cross-circle3.svg"
        className=" delete_query_close_btn"
        alt=""
        onClick={(e) => setDeleteQuery(false)}
      />
      <div className=" p-3 d-flex align-items-center justify-content-center flex-column delete_query_container shadow">
        <div className=" col-12 d-flex align-items-center justify-content-center flex-column text-center">
          <span className="mt-2 mb-5 delete_query_text">
            Are you sure you want to delete this Query?
          </span>
          <div className="col-12 p-0 gap-3 flex-wrap d-flex justify-content-center ">
            <button
              disabled={isInProgress}
              className="btn btn-danger col-sm-5 query_delete_btn"
              onClick={handleDeleteQuery}
            >
              Yes
            </button>
            <button
              disabled={isInProgress}
              className="btn btn-danger col-sm-5 query_delete_btn default_deleteq_uery_no"
              autoFocus
              onClick={(e) => setDeleteQuery(false)}
            >
              No
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteQuery;
